import React, {useState, useEffect, useRef} from 'react';
import {useHistory} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

import ScheduleListComponent from "../schedule/ScheduleListComponent";

const SchedulegroupListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const [schedulegroups, setSchedulegroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(Number(process.env.REACT_APP_LIST_ROW_DEFAULT));
  const dt = useRef(null);
  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: 'id',
    sortOrder: -1,
  });
  const [expandedRows, setExpandedRows] = useState(null);

  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      apiCall('get', '/api/v2/schedule-group' + query)
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setSchedulegroups(response.data.data.items)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: Number(process.env.REACT_APP_LIST_ROW_OP1), value: Number(process.env.REACT_APP_LIST_ROW_OP1)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP2), value: Number(process.env.REACT_APP_LIST_ROW_OP2)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP3), value: Number(process.env.REACT_APP_LIST_ROW_OP3)},
        {label: Number(process.env.REACT_APP_LIST_ROW_OP4), value: Number(process.env.REACT_APP_LIST_ROW_OP4)},
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_schedule_write') &&
          <>
            <Button icon="pi pi-pencil" className="  p-button-warning p-mr-2"
                    tooltip={t('edit')} tooltipOptions={{position: 'left'}}
                    onClick={() => {
                      history.push('/production/schedule-group/update/' + rowData.id)
                    }}/>
            <Button icon="pi pi-plus" className="p-button-success p-mr-2"
                    tooltip={t('addShift')}
                    onClick={() => {
                      history.push('/production/schedule-group?create=schedule&schedulegroupId=' + rowData.id + '&schedulegroupType=' + rowData.type)
                    }}/>
            {/*<Button icon="pi pi-calendar" className=" p-button p-mr-2"*/}
            {/*        tooltip={t('view')} tooltipOptions={{position: 'left'}}*/}
            {/*        onClick={() => {*/}
            {/*        }}/>*/}
          </>
        }
        {localStorage.getItem('roles').toString().includes('role_schedule_write') &&
          <Button icon="pi pi-trash" className="p-button-danger"
                  tooltip={t('delete')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    if (window.confirm('A törlés megerősítésére van szükség!')) {
                      apiCall('delete', '/api/v2/schedule-group/' + rowData.id)
                        .then(response => {
                          window.App.toastShow('success', 'Sikeres törlés!',);
                          loadLazyData();
                        })
                        .catch(error => {
                          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
                        })
                    }
                  }}
          />
        }
      </React.Fragment>
    );
  }

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if(window.App.urlVars().schedulegroupId) {
      setExpandedRows({[window.App.urlVars().schedulegroupId]: true})
    }
  }, [window.App.urlVars().schedulegroupId])

  useEffect(() => {
    loadLazyData();
    window.App.setState({rerenderProjectPage: Math.random()});
  }, [lazyParams, window.App.state.rerenderSchedulegroupList])

  return (
    <>
      <DataTable size={localStorage.getItem('scale')}
                 emptyMessage={t('noResults')}
                 value={schedulegroups} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
                 onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                 onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
                 paginatorTemplate={pager} rows={rows}
                 autoLayout={true}
                 filterDisplay="row"
                 responsiveLayout="scroll"
                 stripedRows
                 ref={dt}
                 rowExpansionTemplate={(rowData) => {
                   return (
                     <>
                        <div className="expanded-section expanded-section--schedule">
                          <h4 className="expanded-section__title">
                            <i className="pi pi-calendar" />
                            {t('shifts')}
                          </h4>
                          <div className="expanded-section__content">
                            <ScheduleListComponent schedulegroupId={rowData.id} scheduleGroupType={rowData.type}/>
                          </div>
                          <div className={"p-grid p-mt-1"}>
                            <div className={"p-col-12 p-lg-6 p-xl-6"}>
                            </div>
                            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                              <Button type="button" label={t('addShiftToGroup')} icon="pi pi-plus"
                                      className="p-button-success p-ml-2"
                                      onClick={() => {
                                        history.push('/production/schedule-group?create=schedule&schedulegroupId=' + rowData.id + '&schedulegroupType=' + rowData.type)
                                      }}
                              />
                            </div>
                          </div>
                       </div>
                     </>
                   )
                 }}
                 dataKey="id"
                 expandedRows={expandedRows}
                 onRowToggle={(e) => {
                   setExpandedRows(e.data);
                 }}
                 onRowExpand={(e) => {
                   history.push('/production/schedule-group?schedulegroupId=' + e.data.id);

                   let id = e.data.id;
                   setExpandedRows({[id]: true});
                 }}
      >
        <Column field="name" header={t('columnName2')} bodyClassName="col-body-font-bold" sortable filter filterPlaceholder={t('columnName2')}></Column>
        <Column field="type" header={t('columnType')} sortable filter filterPlaceholder={t('columnType')} body={(rowData) => {
          if (rowData.type === 'EMPLOYEE_CAPACITY') {
            return (
              <>Munkavállalók beosztása</>
            )
          }
          if (rowData.type === 'MACHINE_CAPACITY') {
            return (
              <>Berendezés kapacitás beosztása</>
            )
          }
          if (rowData.type === 'MACHINE_EMPLOYEE_CAPACITY') {
            return (
              <>Berendezés és munkavállalók beosztása</>
            )
          }
        }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-right p-text-nowrap"}></Column>
        <Column expander style={{width: '3em'}}/>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(SchedulegroupListComponent);
